<div [ngClass]="{'landing-page': true,'show-mobile-menu': showMobileMenu}">
    <!-- The off-screen transform is a static inline style so it is set when the
         element is created, before Angular applies .landing-page. Left to the
         stylesheet alone the panel painted once untransformed, then the class
         arrived with a live 0.5s transition and it visibly slid away on every
         load. The binding drives open/close from here for the same reason. -->
    <div class="mobile-menu" style="transform: translateX(300px)"
        [style.transform]="showMobileMenu ? 'translateX(0)' : 'translateX(300px)'"
        (click)="$event.stopPropagation()">
        <a (click)="scrollTo('#home')" href="javascript:;" class="logo-mobile">
            <span></span>
        </a>
        <ul class="navbar-nav">
            <li class="nav-item"><a (click)="scrollTo('#about')" href="javascript:;">ABOUT</a></li>
            <li class="nav-item"><a (click)="scrollTo('#projects')" href="javascript:;">PROJECTS</a></li>
            <li class="nav-item"><a (click)="scrollTo('#services')" href="javascript:;">SERVICES</a></li>
            <li class="nav-item"><a (click)="scrollTo('#contact')" href="javascript:;">CONTACT</a></li>
        </ul>
    </div>

    <div class="main-container">
        <div class="landing-page-nav">
            <div class="headroom" [ngClass]="'headroom--' + headroomState" [ngStyle]="headroomStyle">
            <nav>
                <div class="container d-flex align-items-center justify-content-between">
                    <a class="navbar-logo pull-left" (click)="scrollTo('#home')" href="javascript:;">
                        <span class="white"></span>
                        <span class="dark"></span>
                    </a>
                    <ul class="navbar-nav d-none d-lg-flex flex-row">
                        <li class="nav-item"><a (click)="scrollTo('#about')" href="javascript:;">ABOUT</a></li>
                        <li class="nav-item"><a (click)="scrollTo('#projects')" href="javascript:;">PROJECTS</a></li>
                        <li class="nav-item"><a (click)="scrollTo('#services')" href="javascript:;">SERVICES</a></li>
                        <li class="nav-item"><a (click)="scrollTo('#contact')" href="javascript:;">CONTACT</a></li>
                    </ul>
                    <span class="mobile-menu-button" (click)="showMobileMenu=!showMobileMenu; $event.stopPropagation()">
                        <i class="simple-icon-menu"></i>
                    </span>
                </div>
            </nav>
            </div>
        </div>


        <div class="content-container" id="home">

            <div class="section home">
                <div class="container">
                    <div class="row home-row">
                        <div class="col-12 col-xl-7 col-lg-8 col-md-10">
                            <div class="home-text">
                                <div class="display-1">HIGH-END<br>BACK-END AND<br>FRONT-END</div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <a class="btn btn-circle btn-outline-semi-light hero-circle-button"
                            (click)="scrollTo('#about')">
                            <i class="simple-icon-arrow-down"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="container" id="about">
                    <div class="row">
                        <div class="col-12 offset-0 col-lg-8 offset-lg-2 text-center">
                            <h1>About Us</h1>
                            <p>
                                Nozemans Software Pte. Ltd. is a Singapore-registered software company. We design,
                                build and run our own products, and we take on consultancy work where the hard part
                                is the part nobody has solved yet.
                                <br>
                                <br>
                                We specialise in early-phase explorations and in making the impossible possible.
                                <br>
                                <br>
                                People, product, <s class="text-muted">process</s> progress. Nothing was ever
                                invented on a Gantt chart.
                            </p>
                        </div>
                    </div>

                    <div class="row pt-4 pb-4" id="services">
                        <div class="col-12 col-sm-6 col-lg-3 mb-4" *ngFor="let f of services">
                            <div class="card h-100">
                                <div class="card-body text-center">
                                    <div>
                                        <i class="{{f.icon + ' large-icon'}}"></i>
                                        <h5 class="mb-3 font-weight-semibold">{{f.title}}</h5>
                                    </div>
                                    <div>
                                        <p class="detail-text">{{f.detail}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row feature-row">
                        <div class="col-12 col-md-6 col-lg-5 d-flex align-items-center">
                            <div class="feature-text-container">
                                <h2>Lauren ten Hoor</h2>
                                <p>
                                    Lauren works across all three sides of innovation: the design that makes an
                                    idea legible, the software that makes it real, and the business model that
                                    decides whether it lasts. Few ideas fail on only one of them.
                                    <br>
                                    <br>
                                    The early phase is where they are most useful — no brief, no spec, nothing
                                    proven yet. They sketch, prototype and build the thing to find out whether the
                                    idea actually holds. Something running this week beats a plan that reads well
                                    next quarter.
                                    <br>
                                    <br>
                                    Lauren puts teams together person by person. Rather than filling a seat on an
                                    org chart, they look for what someone is genuinely good at and give them
                                    exactly that work. It is how small teams end up shipping what bigger ones are
                                    still discussing.
                                    <br>
                                    <br>
                                    They have worked on every stage of building a product — the first messy
                                    research, the prototypes, the design, the code underneath, the testing, the
                                    launch, and the unglamorous years after. Along the way: published research in
                                    biomedical engineering and patents in smart technology.
                                </p>
                                <a href="https://www.linkedin.com/in/lauren-ten-hoor" target="_blank" rel="noopener"
                                    class="btn btn-outline-primary btn-sm mt-3">
                                    <i class="simple-icon-social-linkedin mr-2"></i> LINKEDIN
                                </a>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 offset-lg-1 offset-md-0 d-flex align-items-center">
                            <div class="card w-100 semi-rounded depth-2">
                                <div class="card-body">
                                    <h5 class="mb-4 font-weight-semibold">Nozemans Software Pte. Ltd.</h5>
                                    <table class="table table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td class="text-muted pl-0">Activities</td>
                                                <td>
                                                    Development of software and applications (SSIC 62011)<br>
                                                    Information technology consultancy (SSIC 62021)
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-muted pl-0">Type</td>
                                                <td>Private Company Limited by Shares</td>
                                            </tr>
                                            <tr>
                                                <td class="text-muted pl-0">Status</td>
                                                <td>Live Company</td>
                                            </tr>
                                            <tr>
                                                <td class="text-muted pl-0">Incorporated</td>
                                                <td>19 February 2025</td>
                                            </tr>
                                            <tr>
                                                <td class="text-muted pl-0">UEN</td>
                                                <td>202507332E</td>
                                            </tr>
                                            <tr>
                                                <td class="text-muted pl-0">Registered office</td>
                                                <td>160 Robinson Road #14-04<br>Singapore 068914</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section background">
                <div class="container" id="projects">
                    <div class="row">
                        <div class="col-12 offset-0 col-lg-8 offset-lg-2 text-center">
                            <h1>What We Build</h1>
                            <p>
                                Products we own end to end — from the cloud platform underneath to the apps
                                running on top of it.
                            </p>
                        </div>
                    </div>

                    <div *ngFor="let project of projects;let i = index">
                        <div *ngIf="i%2==0" class="row feature-row">
                            <div class="col-12 col-md-6 col-lg-5 d-flex align-items-center">
                                <div class="feature-text-container">
                                    <h2>{{project.title}}</h2>
                                    <h3 class="mb-4">{{project.subtitle}}</h3>
                                    <p [innerHTML]="project.detail"></p>
                                    <a [href]="project.url" target="_blank" rel="noopener"
                                        class="btn btn-outline-primary btn-sm mt-3">
                                        VISIT {{project.title | uppercase}} <i class="simple-icon-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6 offset-lg-1 offset-md-0 position-relative">
                                <a [href]="project.url" target="_blank" rel="noopener">
                                    <img [alt]="project.title" [src]="project.img"
                                        class="feature-image-right feature-image-charts position-relative img-fluid semi-rounded depth-2" />
                                </a>
                            </div>
                        </div>
                        <div *ngIf="i%2==1" class="row feature-row">
                            <div class="col-12 col-md-6 col-lg-6 order-2 order-md-1">
                                <a [href]="project.url" target="_blank" rel="noopener">
                                    <img [alt]="project.title" [src]="project.img"
                                        class="feature-image-left feature-image-charts img-fluid semi-rounded depth-2" />
                                </a>
                            </div>
                            <div
                                class="col-12 col-md-6 offset-md-0 col-lg-5 offset-lg-1 d-flex align-items-center order-1 order-md-2">
                                <div class="feature-text-container">
                                    <h2>{{project.title}}</h2>
                                    <h3 class="mb-4">{{project.subtitle}}</h3>
                                    <p [innerHTML]="project.detail"></p>
                                    <a [href]="project.url" target="_blank" rel="noopener"
                                        class="btn btn-outline-primary btn-sm mt-3">
                                        VISIT {{project.title | uppercase}} <i class="simple-icon-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="container" id="opensource">
                    <div class="row">
                        <div class="col-12 offset-0 col-lg-8 offset-lg-2 text-center">
                            <i class="iconsminds-gears large-icon"></i>
                            <h1>devclaw</h1>
                            <p>
                                Turn any group chat into a dev team that ships.
                                <br>
                                <br>
                                A plugin for OpenClaw that turns an orchestrator agent into a development manager.
                                It hires workers at the tier the task actually needs — junior, medior or senior —
                                runs them across several repositories in parallel, and keeps GitHub and GitLab
                                issues as the single source of truth. Matching the model to the job instead of
                                using the biggest one everywhere cuts token cost dramatically.
                            </p>
                            <a href="https://github.com/laurentenhoor/devclaw" target="_blank" rel="noopener"
                                class="btn btn-outline-primary btn-sm mt-3">
                                <i class="simple-icon-social-github mr-2"></i> VIEW ON GITHUB
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section background background-no-bottom mb-0 pb-0">
                <div class="container" id="contact">
                    <div class="row">
                        <div class="col-12 offset-0 col-lg-8 offset-lg-2 text-center">
                            <h1>Get in Touch</h1>
                            <p>
                                Building something where the hard part isn't solved yet? Let's talk.
                                <br>
                                <br>
                                Nozemans Software Pte. Ltd.<br>
                                160 Robinson Road #14-04<br>
                                Singapore Business Federation Center<br>
                                Singapore 068914
                            </p>
                            <div class="d-flex flex-wrap justify-content-center mt-3 mb-5">
                                <a href="mailto:lauren@nozemans.com"
                                    class="btn btn-secondary btn-xl m-2">
                                    <i class="simple-icon-envelope mr-2"></i> LAUREN&#64;NOZEMANS.COM
                                </a>
                                <a href="https://wa.me/31621891651" target="_blank" rel="noopener"
                                    class="btn btn-secondary btn-xl m-2">
                                    <i class="simple-icon-bubble mr-2"></i> +31 6 2189 1651
                                </a>
                                <a href="https://www.linkedin.com/in/lauren-ten-hoor" target="_blank" rel="noopener"
                                    class="btn btn-secondary btn-xl m-2">
                                    <i class="simple-icon-social-linkedin mr-2"></i> LINKEDIN
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section footer mb-0">
                <div class="container">
                    <div class="row footer-row">
                        <div class="col-12 text-right">
                            <a class="btn btn-circle btn-outline-semi-light footer-circle-button"
                                (click)="scrollTo('#home')" href="javascript:;"><i class="simple-icon-arrow-up"></i></a>
                        </div>
                        <div class="col-12 text-center footer-content">
                            <a (click)="scrollTo('#home')" href="javascript:;">
                                <img class="footer-logo" alt="footer logo"
                                    src="/assets/logos/white-full-web.svg" />
                            </a>
                        </div>
                    </div>
                </div>
                <div class="container copyright pt-5 pb-5">
                    <div class="row">
                        <div class="col-12"></div>
                        <div class="col-12 text-center">
                            <p class="mb-0">©{{currentYear}} - Nozemans Software Pte. Ltd. - UEN 202507332E</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
